import { gql } from "@apollo/client";

export const codeFragment = gql`
    fragment CodeFragment on Licence {
        id
        code
        activatedAt
        activeFrom
        activeTill
        createdAt
        package {
            name
        }
        type
    }
`;
